import { useState, useEffect } from 'react';
import LinkButton from '@core/components/linkbutton/LinkButton';

import { smartImportCheckService } from 'services/cv';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import PremiumFeatureBanner from '@core/components/premiumfeaturebanner/PremiumFeatureBanner';
import ActionButton from '@core/components/actionbutton/ActionButton';
import CarouselWrapper from '@core/components/carouselwrapper/CarouselWrapper';
import { resumeTemplateList } from 'constants/resume-template-list.const';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import Modal from '@core/components/Modal/Modal';
import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';
import ImportResume from './ImportResume';

import { InfoCircle } from 'iconsax-react';

import classes from './EmptyState.module.scss';


const EmptyState = ({ nameError, refetch, smart_cv_import_access_status }) => {
	const [isImportStarted, setIsImportStarted] = useState(false);
	const [resumeStatus, setResumeStatus] = useState(null);
	const router = useRouter();
	const {
		showModal: showUploadResumeModal,
		destroyModal: destroyUploadResumeModal,
		show: showUploadResume
	} = UseModal();
	const { toast, ToastContainer } = UseToast();
	const { data: importStatus, refetch: refetchImportStatus } = useQuery('smart-import-status', smartImportCheckService, {
		onSuccess: (data) => {
			setResumeStatus(data?.data?.status);
			if (data?.data?.status === 'saved')
				refetch();
		}
	});

	useEffect(() => {
		let interval;
		if (isImportStarted && (resumeStatus === 'pending' || resumeStatus === 'parsed')) {
			refetchImportStatus(); // immediate check
			interval = setInterval(() => {
				refetchImportStatus();
			}, 10000);
		}
		return () => clearInterval(interval);
	}, [isImportStarted, resumeStatus, refetchImportStatus]);

	const onUploadResumeSuccess = () => {
		setIsImportStarted(true);
		refetchImportStatus();
		destroyUploadResumeModal();
	}
	const checkStatus = () => {
		if (nameError === 422) {
			return true;
		}
		else if (resumeStatus === 'pending' || resumeStatus === 'parsed') {
			return true;
		}
		else {
			return false;
		}
	}

	return (
		<>
			{/* <div
			className={`${classes['my-resume-empty-container']} d-flex flex-column align-items-center justify-content-center`}>
			<Book />
			<h3>You haven’t created your resume yet.</h3>
			{false ? (
				<div className={classes['line']}>
					<PremiumFeatureBanner />
				</div>
			) : (
				<>
					<p>Start creating your public profile and get ready for job opportunities.</p>
					<LinkButton to="/profile/my-resume/new" kind="primary-color">
						Start creating my resume
					</LinkButton>
				</>
			)
			}
			</div> */}

			<div className={classes['wrapper']}>
				<div className={classes['box']}>
					<div className={classes['badge']}>
						Professional Profile
					</div>
					<h2>
						Build Your Professional Pharma Profile
					</h2>
					<p>Create a structured profile, optimize it for target roles, and use it to become visible to recruiters and the Pharmuni community.</p>
					<div className='d-flex flex-column flex-lg-row align-items-lg-start align-items-center justify-content-start gap-3 '>
						<div className={`${classes['option']} ${classes['primary']}`}>
							<div>
								<h3>Create from Scratch</h3>
								<p>Start with guided steps and build your professional profile from the beginning.</p>
							</div>
							<ActionButton disabled={checkStatus()} kind='primary' onClick={() => router.push('/profile/my-resume/new')}>Start Building</ActionButton>
						</div>
						<div className={`${classes['option']} ${classes['secondary']}`}>
							<div>
								<h3>Import Resume</h3>
								<p>Upload your CV and let AI extract your work experience, education, skills, and profile basics automatically.</p>
							</div>
							<ActionButton className='m-0' disabled={checkStatus() || smart_cv_import_access_status === 'disabled'} onClick={showUploadResumeModal} kind="secondary_main">Import Resume</ActionButton>
						</div>
						{/* <div className={`${classes['option']} ${classes['secondary']}`}>
						<div>
							<h3>Import LinkedIn</h3>
							<p>Import your LinkedIn profile to get started faster.</p>
						</div>
						<ActionButton kind="secondary_main">Import LinkedIn</ActionButton>
					</div> */}
					</div>
					{resumeStatus === 'pending' && (
						<div className='d-flex align-items-center gap-2 mt-4'>
							<InfoCircle size={24} color='#18BBA8' variant='TwoTone' />
							<p className='m-0'><strong>Your resume is being processed. We will notify you once it's ready to review and edit.</strong></p>
						</div>
					)}
					{nameError === 422 && (
						<div className='d-flex align-items-center gap-2 mt-4'>
							<InfoCircle size={24} color='#E97777' variant='TwoTone' />
							<p className='m-0'><strong>To start building your resume, please add your full name to your profile.</strong></p>
						</div>
					)}
				</div>
				<div className={classes['box']}>
					<h1>How It Works</h1>
					<p>A simple flow that turns profile creation into job readiness.</p>
					<div className='d-flex flex-column flex-lg-row align-items-lg-start align-items-center justify-content-start gap-3 '>
						<div className={`${classes['item']}`}>
							<div className={classes['number']}>
								1
							</div>
							<h3>Create your profile</h3>
							<p >Build from scratch or import your CV with AI to populate your experience, education, and skills.</p>
						</div>
						<div className={`${classes['item']}`}>
							<div className={classes['number']}>
								2
							</div>
							<h3>Optimize for a role</h3>
							<p >Tailor your profile for QA, Regulatory, GMP, PV, and other pharma roles with tailored recommendations.</p>

						</div>
						<div className={`${classes['item']}`}>
							<div className={classes['number']}>
								3
							</div>
							<h3>Get discovered</h3>
							<p>Make your profile visible to recruiters and the Pharmuni community so your strengths are easier to understand.</p>
						</div>
					</div>
				</div>
				{/* <div className={`${classes['box']} ${classes['recommendation']}`}>
				<div>
					<h5>Recommended first action</h5>
					<p>Prefill the basics from the existing Pharmuni account to avoid an empty start.</p>
				</div>
				<ActionButton kind="primary">Autofill from profile</ActionButton>
			</div> */}
				{/* <div className={`${classes['box']} ${classes['resume-template']}`}>
				<h2 className='mb-4'>Stand out with professional resume templates</h2>
				<CarouselWrapper
					centeredSlides={false}
					slidesPerView={3}
					delay={3000}
					slides={resumeTemplateList.map((template) => (
						<div className={classes['slide']} key={template.id}>
							<img src={template.image} />
							<h5>{template.title}</h5>
							<p>{template.description}</p>
						</div>
					))} />
			</div> */}
			</div>

			<Modal isGoPermium={true} header={false} backgroundColor='#fff5e5' type={MOBILE_SLIDE_UP} show={showUploadResume} closeHandler={destroyUploadResumeModal}>
				<ImportResume toast={toast} setResumeStatus={setResumeStatus} onUploadResumeSuccess={onUploadResumeSuccess} />
			</Modal>
			<ToastContainer />
		</>
	);
};

export default EmptyState;
